<template>
    <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="公司名称" prop="corpName">
                    <Input v-model="info.corpName"
                        placeholder :maxlength="256"
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="公司电话" prop="phone">
                    <Input v-model="info.phone"
                        placeholder :maxlength="256"
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="公司传真" prop="fax">
                    <Input v-model="info.fax" 
                        placeholder :maxlength="256" 
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="公司地址" prop="addr">
                    <Input v-model="info.addr" 
                        placeholder :maxlength="256" 
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="公司邮箱" prop="email">
                    <Input v-model="info.email" 
                        placeholder :maxlength="256"
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="客服热线" prop="hotline">
                    <Input v-model="info.hotline" 
                        placeholder :maxlength="256" 
                        :disabled="disabled">
                    </Input>
                </FormItem>
            </Col>
        </Row>
        <div v-if="$can('add') || $can('update')" style="text-align: center">
            <Button v-if="editing" type="primary"
                :disabled="loading" @click="toSave">
                保存
            </Button>
            <Button type="default" @click="toEdit" v-else>
                编辑
            </Button>
        </div>
    </Form>
</template>
<script>
import PreviewUpload from '_c/preview-upload'
import { corpView, addOrUpdate } from '@/api/information-manage'
export default {
    data() {
        return {
            loading: false,
            editing: false,
            info: {
                id: '',
                corpName: '',   //公司名称
                phone: '',      //公司电话
                fax: '',        //公司传真
                addr: '',       //公司地址
                email: '',      //公司邮箱
                hotline: '',    //客服热线
                ver: ''
            },
            ruleValidate: {
                corpName: [
                    {
                        required: true,
                        message: '公司名称必填'
                    }
                ]
            }
        }
    },
    computed: {
        disabled() {
            return this.loading || !this.editing
        }
    },
    components: {},
    methods: {
        fetch() {
            this.loading = true
            corpView()
                .then(res => {
                    var viewData = res.data
                    Object.keys(this.info).forEach(
                        name => (this.info[name] = viewData[name])
                    )
                })
                .finally(() => (this.loading = false))
        },
        toEdit() {
            this.editing = true
        },
        toSave() {
            var $info = this.$refs.info
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    return addOrUpdate(formData)
                })
                .then(res => {
                    this.$Message.success(this.$t('tips.save.success'))
                })
                .finally(() => {
                    this.loading = false
                    this.editing = false
                })
        }
    },
    created() {
        this.fetch()
    }
}
</script>